/**
 * 圆形按钮的展示层封装。
 * 通过 tag 参数既能输出 button，也能输出 a 等标签，同时统一尺寸和主题类名。
 */
import React from 'react';
import classNames from 'classnames';

export interface Props
    extends React.HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
    /** 要渲染的 HTML 标签，默认 button。 */
    tag?: keyof JSX.IntrinsicElements;
    /** 颜色主题；目前只保留原设计的 default。 */
    variant?: 'default';
    /** 可选尺寸，对应 round-btn-md / round-btn-lg。 */
    size?: 'md' | 'lg';
}

const RoundButton = React.forwardRef<HTMLElement, Props>(
    (
        { children, variant = 'default', tag = 'button', size, ...props },
        ref,
    ) => {
        // 标签名直到运行时才确定，所以用 createElement 比固定 JSX 标签更直接。
        return React.createElement(
            tag,
            {
                ...props,
                ref,
                className: classNames(
                    'round-btn',
                    `round-btn-${variant}`,
                    size ? `round-btn-${size}` : '',
                    props.className,
                ),
            },
            children,
        );

        // 下方是原作者保留的等价 JSX 思路；动态 Tag 的 ref 类型更难表达，因此未采用。
        // return (
        //     <Tag
        //         {...props}
        //         ref={ref}
        //         className={classNames(
        //             'round-btn',
        //             `round-btn-${variant}`,
        //             size ? `round-btn-${size}` : '',
        //             props.className,
        //         )}
        //     >
        //         {children}
        //     </Tag>
        // );
    },
);

RoundButton.displayName = 'RoundButton';

export default RoundButton;
